import { render } from "./Illust.vue?vue&type=template&id=b16c2f74"
const script = {}
script.render = render

export default script